export enum Status {
  REOPENED = 'REOPENED',
  RESERVED = 'RESERVED',
  PENDING = 'PENDING',
  INPROGRESS = 'INPROGRESS',
}

export type StatusValues = `${Status}`
